import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPlay = /*@__PURE__*/ proxyCustomElement(class CosmosIconPlay extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '75f5b52e8ec0ed900fd283c1d1ef11b20bd6ba77', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '126e63adcd8f0c1fb1ed53874a89c217315ddf5d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd72b1d24b155cf4ee8605a33076b19a429c26b23', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.22 17.44 10.38-5.905a.61.61 0 0 0 .283-.531.61.61 0 0 0-.282-.531L7.22 4.568a.43.43 0 0 0-.495.023.62.62 0 0 0-.225.52v11.81a.62.62 0 0 0 .239.492.43.43 0 0 0 .48.027", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-play", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-play"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-play":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPlay);
            }
            break;
    } });
}

export { CosmosIconPlay as C, defineCustomElement as d };
